import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function passwordsDontMatch(formGroup: UntypedFormGroup) {
  const newPassword = formGroup.get('newPassword');
  const confirmPassword = formGroup.get('confirmPassword');

  if (!newPassword || !confirmPassword) return null;
  if (!newPassword.value || !confirmPassword.value) return null;

  return newPassword.value !== confirmPassword.value
    ? { passwordsDontMatch: true }
    : null;
}

export function passwordsSame(formGroup: UntypedFormGroup) {
  const newPassword = formGroup.get('newPassword');
  const oldPassword = formGroup.get('oldPassword');

  if (!newPassword || !oldPassword) return null;
  if (!newPassword.value || !oldPassword.value) return null;

  return newPassword.value === oldPassword.value
    ? { passwordsSame: true }
    : null;
}

export function passwordLetterRequired(
  formGroup: UntypedFormGroup,
): ValidationErrors | null {
  const newPassword = formGroup.get('newPassword');

  if (!newPassword || !newPassword.value) return null;

  return !/[a-zA-Z]/.test(newPassword.value)
    ? { passwordLetterRequired: true }
    : null;
}

export function passwordUppercaseRequired(
  formGroup: UntypedFormGroup,
): ValidationErrors | null {
  const newPassword = formGroup.get('newPassword');

  if (!newPassword || !newPassword.value) return null;

  return !/[A-Z]/.test(newPassword.value)
    ? { passwordUppercaseRequired: true }
    : null;
}

export function passwordLowercaseRequired(
  formGroup: UntypedFormGroup,
): ValidationErrors | null {
  const newPassword = formGroup.get('newPassword');

  if (!newPassword || !newPassword.value) return null;

  return !/[a-z]/.test(newPassword.value)
    ? { passwordLowercaseRequired: true }
    : null;
}

export function passwordSpecialCharRequired(
  formGroup: UntypedFormGroup,
): ValidationErrors | null {
  const newPassword = formGroup.get('newPassword');

  if (!newPassword || !newPassword.value) return null;

  return !/[!@#$%^&*(),.?":{}|<>]/.test(newPassword.value)
    ? { passwordSpecialCharRequired: true }
    : null;
}

export function passwordNumericalCharRequired(
  formGroup: UntypedFormGroup,
): ValidationErrors | null {
  const newPassword = formGroup.get('newPassword');

  if (!newPassword || !newPassword.value) return null;

  return !/\d/.test(newPassword.value)
    ? { passwordNumericalCharRequired: true }
    : null;
}
